import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { User } from 'lucide-react';
import NotificationCenter from './NotificationCenter';
import { useRoleAccess } from '../../hooks/useRoleAccess';

const isAddServiceCaseWorkspace = (pathname) =>
  pathname === '/add-service' || pathname.startsWith('/add-service/');

const LayoutHeader = () => {
  const { isAdmin, isAgent, isManager } = useRoleAccess();

  return (
    <div className="flex justify-end items-center gap-2 mb-4 pt-3 pr-3 shrink-0">
      {(isAdmin || isAgent || isManager) && <NotificationCenter />}
      <User className="nav-user" />
    </div>
  );
};

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { pathname } = useLocation();
  const caseWorkspaceShell = isAddServiceCaseWorkspace(pathname);

  if (caseWorkspaceShell) {
    return (
      <div className="flex w-100 rounded-lg">
        <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />

        {/* Single page scroll (window): no overflow-y-auto here — avoids double scrollbars + blank gap with outer scroll */}
        <div className="bodymainbg flex min-w-0 flex-1 flex-col">
          <div className="p-4 pt-0 pb0 pr-0">
            <div className="contentbg">
              <LayoutHeader />
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full rounded-lg w-100">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />

      <div className="flex-1 bodymainbg overflow-hidden">
        <div className="p-4 pt-0 pb0 pr-0 h-full">
          <div className="contentbg flex flex-col min-h-0">
            <LayoutHeader />
            <div className="min-h-0 flex-1 overflow-hidden">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
